import { makeStyles } from "@mui/styles";
import React from "react";
import { Typography } from "../Typography";
import img_adm_module2 from "../../asset/img_adm_module2.jpg";

const useStyles = makeStyles((theme) => ({
  container: {
    // maxWdith: 850,
    width: 600,
    height: 300,
    display: "flex",
    flexDirection: "row",
  },
  moduleImg: {
    width: 300,
    height: 300,
    borderRadius: "20px 0px 0px 20px",
    // borderRight: "1px solid orange",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fcf5e3",
  },
  moduleTxt: {
    width: 300,
    display: "flex",
    borderRadius: "0px 20px 20px 0px",
    // border: "1px solid blue",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "column",
    backgroundColor: "#FDF5FD",
    padding: "38px 13px 38px 13px",
  },
}));

export const ModuleContent2 = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <img src={img_adm_module2} className={classes.moduleImg} alt="module2" />
      <div className={classes.moduleTxt}>
        <div
          style={{
            backgroundColor: "#EB5FE5",
            borderRadius: 10,
            width: 97,
            height: 28,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="SimModuleText" style={{ color: "#fff" }}>
            간호관리 모듈2
          </Typography>
        </div>

        <div style={{ wordBreak: "keep-all" }}>
          <Typography
            variant="SimModuleSubText"
            style={{ textAlign: "justify", fontWeight: 700 }}
          >
            퇴원관리
          </Typography>
          <br />
          <Typography
            variant="SimModuleSubText"
            style={{ textAlign: "justify" }}
          >
            퇴원환자를 위한 퇴원간호의 개념을 학습하고 임상에서 빈번히 발생할 수
            있는 퇴원간호 상황에서 이를 조정해 나가는 바람직한 간호관리활동을
            시뮬레이션으로 학습함
          </Typography>
        </div>
      </div>
    </div>
  );
};
